import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { IUserData } from 'src/app/@types/UserData'; import { lastValueFrom } from 'rxjs';
import { from } from 'rxjs'; import { Capacitor } from '@capacitor/core';
import { ConfGeraisService } from 'src/app/services/conf-gerais.service';
import { ConfirmationService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { MessageService } from 'primeng/api'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators'; import { AfterViewInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { BillingService } from 'src/app/services/billing.service';
export interface Stores {
	store_id: number;
	store_name: string;
	store_domain: string;
}
@Component({
	templateUrl: './register.component.html'
})
export class RegisterComponent implements AfterViewInit, OnInit {

	confirmed: boolean = false;
	errorPassword: boolean = false;
	password: string = "";
	store_subdoman: string = "";
	issueForm?: FormGroup;
	new_email: string = "";
	errorEmail: boolean = false;
	errorDisponibilidadeEmal: boolean = false;
	loading: boolean = false;
	isLogged: boolean = false;
	displayStyle: string = 'none';
	name: string = "";
	message: string = "";
	store_name: string = "";
	full_name: string = "";
	errorName: boolean = false;
	errorURL: boolean = false;
	errorStoreName: boolean = false;
	criarLoagind: boolean = false;
	userData: IUserData | null = null;
	constructor(
		private layoutService: LayoutService,
		private configService: ConfGeraisService,
		private authService: AuthService, private errorHandler: ErrorHandlerService,
		private messageService: MessageService,
		private router: Router,
		private httpClient: HttpClient,
		private localstorageService: LocalstorageService,
		private billingService: BillingService,
		public fb: FormBuilder,
		private confirmationService: ConfirmationService
	) {
	  console.log('[Capacitor] referenced in RegisterComponent');
		this.issueForm = this.fb.group({
			// defina os controles do formulário aqui
			// exemplo: 'name': ['']
		});
	}

	get dark(): boolean {
		return this.layoutService.config.colorScheme !== 'light';
	}

	ngAfterViewInit(): void {
		const layoutContainer = document.querySelector('.layout-container');

		if (layoutContainer) {
			this.isDark =
				this.layoutService.config.colorScheme === 'dark' ||
				this.layoutService.config.colorScheme === 'dim';

			this.logoSrc = this.isDark
				? 'assets/Logo_escuro_sem.png'
				: 'assets/Logo_claro_sem.svg';
		}
	}
	isDark: boolean = false;
	logoSrc?: string = 'assets/Logo_claro_sem.svg';
	isAndroidApp = false;
	isAndroidBrowser = false;
	ngOnInit(): void {
		// const ua = navigator.userAgent.toLowerCase();
		// const isAndroid = ua.includes('android');
		// const isWeb = !Capacitor.isNativePlatform();
		// const isApp = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
		// this.isAndroidApp = isApp;
		// this.isAndroidBrowser = isAndroid && isWeb;
	}
	@ViewChild('promoVideo', { static: false }) promoVideo!: ElementRef<HTMLVideoElement>;
	isPlaying = false;
	togglePromoVideo() {
		const video = this.promoVideo.nativeElement;

		if (video.paused) {
			video.play();
			this.isPlaying = true;
		} else {
			video.pause();
			this.isPlaying = false;
		}
	}
	checkPassword(): void {
		this.errorPassword = !this.password || this.password.length < 6;
	}


	async onLogin(): Promise<void> {
		const email = this.new_email;
		const pass = this.password;

		this.loading = true;
		const isMobileApp = Capacitor.isNativePlatform();

		try {
			const res = await this.authService.login(email, pass);
			console.log('[Login] Resposta da API:', res);

			if (isMobileApp) {
				this.authService.setAccessToken(res.access_token, true);
				this.getUserLogged(res.access_token);
			} else {
				console.log('[Login] SPA: aguardando persistência de cookie...');
				this.getUserLogged();
			}
		} catch (error: any) {
			this.loading = false;
			const status = error?.status;
			this.errorHandler.handle(error, 'Email não encontrado');
		}
	}



	async getUserLogged(accessToken?: string): Promise<void> {
		this.loading = true;

		try {
			const resp = await lastValueFrom(this.authService.me(accessToken));

			console.log('[getUserLogged] Usuário logado:', JSON.stringify(resp, null, 2));

			if (resp) {
				localStorage.setItem('user_name', resp.username);
				if (resp.stores?.length) {
					const store = resp.stores[0] as Stores;
					localStorage.setItem('store_data', JSON.stringify({
						store_id: store.store_id,
						store_name: store.store_name,
						store_domain: store.store_domain
					}));

					localStorage.setItem('ss_SelectedStoreId', store.store_id.toString());

					this.setUserToLocalStorageAndRedirect(accessToken || '', resp);
					this.isLogged = true;
					this.userData = resp;

					this.router.navigate(['/']);
				}


			}

		} catch (err: any) {
			console.error('Erro ao carregar usuário logado:', JSON.stringify(err, null, 2));
			if (err?.error?.message === 'Unauthenticated.') {
				this.displayStyle = 'block';
				localStorage.removeItem('access_token');
				localStorage.removeItem('access_token_ebanking');
				localStorage.removeItem('domain_store');
				localStorage.removeItem('SelectedStoreId');
			}
		} finally {
			this.loading = false;
		}
	}
	wallets: any[] = [];
	getWallets() {
		console.log('Wallets');
		this.authService.wallet().then(wallets => {
			this.wallets = wallets;
			// Agora, você tem um array de carteiras e pode obter os IDs.
			const ids = wallets.map(wallet => wallet.id);
			console.log(ids); // Aqui estão todos os IDs das carteiras
			this.billingService.setWalletId(ids[0]);

		}).catch(error => {
			console.error('Erro ao obter as carteiras:', error);
		});
	}
	setUserToLocalStorageAndRedirect(access_token: string, user: IUserData): void {
		const isApp = Capacitor.isNativePlatform();

		if (isApp) {
			localStorage.removeItem("access_token");
			this.authService.setAccessToken(access_token, false);
		}

		this.authService.setUser(user.id);
		this.authService.setUserName(user.username);
		this.authService.setUserID(user.id);

		if (user.trial_date) {
			this.authService.setUserTrial(user.trial_date);
		}

		if (user.url_image) {
			this.authService.setUserAvatar(user.url_image);
		}

		if (user.stores && typeof user.stores[0] !== 'number') {
			const store_id = user.stores[0].store_id;
			this.localstorageService.setSelectedStoreId(store_id);

			this.authService.getStoreById(store_id).subscribe(
				response => {
					const storeLinkSubdomain = response[0].store_link_subdomain;
					this.localstorageService.setDomain(storeLinkSubdomain);
					if (response && response.length > 0) {
						const storeLinkSubdomain = response[0].store_link_subdomain;
						this.localstorageService.setDomain(storeLinkSubdomain);

						const storeName = storeLinkSubdomain.split('.')[0];
						this.localstorageService.setSelectedStoreName(storeName);
					} else {
						this.localstorageService.setDomain(null);
					}

					// Redirecionamento
					this.router.navigate(['/']);
				},
				error => {
					console.error('Erro ao buscar loja', error);
				}
			);
		}
	}
	getAccessToken(): string {
		return localStorage.getItem("access_token") || '';
	}
	generateUniqueId(): string {
		let uniqueString = '';
		while (uniqueString.length < 6) {
			uniqueString += Math.random().toString(36).substring(2, 8);
		}
		return uniqueString.substring(0, 6);
	}
	criarConta() {
		if (this.name.trim().length === 0) {
			this.errorName = true;
		}
		if (this.store_name.trim().length === 0) {
			this.errorStoreName = true;
		}
		if (this.password.length < 6) {
			this.errorPassword = true;
		}
		if (!this.isValidEmail(this.new_email)) {
			this.errorEmail = true;
		}


		if (this.errorName || this.errorStoreName || this.errorPassword || this.errorEmail || this.errorDisponibilidadeEmal) {
			return;
		}
		this.store_subdoman = this.store_name.replace(/\s/g, '');
		//this.store_subdoman = this.store_subdoman + this.generateUniqueId();
		this.store_subdoman = this.store_subdoman;// + this.generateUniqueId();
		this.criarLoagind = true;
		this.issueForm = this.fb.group({
			"user": {
				"name": this.name,
				"surname": this.full_name,
				"email": this.new_email,
				"password": this.password,
				"status": 1,
			},
			"wallet": {
				"wallet_name": "Carteira Principal",
				"access_level": 1
			},
			"store": {
				"store_name": this.store_name,
				"store_description": "",
				"store_link_subdomain": this.store_subdoman + ".slicksell.com.br",
				"store_link_domain": null,
				"support_email": this.new_email,
				"support_phone_number": "",
				"support_whatsapp": "",
				"support_whatsapp_status": 1,
				"zipcode": "",
				"store_street": "",
				"store_number": "",
				"store_district": "",
				"store_city": "",
				"store_complement": "",
				"status": 1
			},
			"store_settings": {
				"logo": "",
				"favicon": "",
				"background_color": "#671abc",
				"background_font_color": "#671abc",
				"footer_color": "#671cbc",
				"footer_font_color": "#671cbc",
				"navigation_menu_color": "#671cbc",
				"navigation_menu_font_color": "#671cbc",
				"regular_buttons_color": "#671cbc",
				"regular_buttons_font_color": "#671cbc",
				"buy_button_color": "#671cbc",
				"buy_button_font_color": "#671cbc",
				"add_cart_button_color": "#671cbc",
				"add_cart_button_font_color": "#671cbc",
				"maximum_cashback_fixed": "100",
				"notification_status": "1",
				"notification_via_email": "1",
				"notification_via_push": "1",
				"notification_via_whatsapp": "1",
				"subs_re_payment": "0",
				"subs_cancell_days": "0",
				"subs_billing_days": "0",
				"checkout_pix": "0",
				"checkout_slip": "0",
				"checkout_card": "0"
			}
		});
		this.configService.createOnboarding(this.issueForm.value).subscribe({
			next: (res: any) => {
				console.log('res', res);
				this.criarLoagind = false;
				this.onLogin();
				this.messageService.add({
					severity: 'success',
					summary: 'Conta criada',
					detail: 'A Conta foi criada com sucesso!'
				});
			},
			error: (error: any) => {
				this.criarLoagind = false;
				console.log('caiu no erro: ' + error)
				let message = '';
				if (error.status === 400 || error.status === 403 || error.status === 401 || error.status === 422 || error.status === 405) {
					message = error.error.message;
				} else if (error.status === 500) {
					message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
				}

				if (message) {
					this.showErrorDialog(message);
				}
			}
		});

	}
	checkInputName() {
		this.errorName = false;
	}
	validateName() {
		const v = (this.name ?? '').trim();
		this.errorName = v.length === 0;
	}
	validateStoreName() {
		const v = (this.store_name ?? '').trim();
		this.errorStoreName = v.length === 0;
	}

	checkInputStoreName() {
		this.errorStoreName = false;
	}
	showErrorDialog(message: string) {
		this.confirmationService.confirm({
			message: message,
			header: 'Erro',
			icon: 'pi pi-times',
			accept: () => {
			}
		});
	}
	filterSpecialChars(event: KeyboardEvent) {
		// Permite apenas letras (maiúsculas e minúsculas), números e espaço
		if (!/^[a-zA-Z0-9 ]$/.test(event.key)) {
			event.preventDefault();
		}
	}

	filterSpecialCharsNames(event: KeyboardEvent) {
		// Permite letras (maiúsculas e minúsculas), números, espaço, acentos e cedilha
		if (!/^[a-zA-Z0-9 çÇáéíóúÁÉÍÓÚàÀãÃõÕâÂêÊîÎôÔûÛüÜñÑ]+$/.test(event.key)) {
			event.preventDefault();
		}
	}
	timeOut: any;
	checkEmail() {
		clearTimeout(this.timeOut);

		// só verifica disponibilidade se o formato do email for válido
		if (!this.isValidEmail(this.new_email)) {
			this.errorDisponibilidadeEmal = false;
			return;
		}

		this.timeOut = setTimeout(() => {
			this.errorDisponibilidadeEmal = false;
			this.configService.verificarDisponibilidadeEmail(this.new_email).subscribe({
				next: (res: any) => {
					// se não existe, mantém como false
					this.errorDisponibilidadeEmal = false;
				},
				error: () => {
					this.errorDisponibilidadeEmal = true;
				}
			});
		}, 750);
	}
	private debounceTimer: any = null;
	formToSave3() {
		this.errorURL = false;
		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => {
			this.configService.verificarDisponibilidadeSubdominio(this.store_subdoman).subscribe({
				next: (res: any) => {
					if (res.message == "Não existe Loja com o subdomínio informado.") {
						this.errorURL = false;
					}
					console.log(res);
				},
				error: (error: any) => {
					this.errorURL = true;
					console.log(error);
					console.error('Error response', error);
					if (error.status === 400 || error.status === 403 || error.status === 401) {
						//message = error.error.message;
						this.message = error.error.message;
					} else if (error.status === 500) {
						//message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
						this.message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
					}

					// if (message) {
					//   this.showErrorDialog(message);
					// }
				}
			});
		}, 750);

	}
	checkEmailValid(): void {
		this.errorEmail = false;
		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => {
			this.errorEmail = !this.isValidEmail(this.new_email);
		}, 1500);
	}
	isValidEmail(email: string): boolean {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}
}

